<template>
  <div>
    <van-col :span="24" style="text-align: center;">
      <img src="@/assets/mlogo.png" style="width: 100px" />
    </van-col>
    <van-col :span="24" style="text-align: right; padding-right: 10px;">
      欢迎您，{{ userInfo.emp_name }}&nbsp;&nbsp;
      <van-tag plain type="danger" @click="logout">退出系统</van-tag>
    </van-col>
    <van-col :span="24">
      <van-divider content-position="center" :style="{ color: '#13C2C2', borderColor:
        '#13C2C2', padding: '0 16px', fontSize: '16px' }">
        客户预定
      </van-divider>
    </van-col>
    <van-col :span="24">
      <van-grid>
        <van-grid-item icon="friends-o" text="新增预订单" @click="redirect('/sell/order')" />
        <van-grid-item icon="orders-o" text="预订单管理" @click="redirect('/sell/order-manage')" />
      </van-grid>
    </van-col>
    <van-col :span="24">
      <van-divider content-position="center" :style="{ color: '#13C2C2', borderColor:
        '#13C2C2', padding: '0 16px', fontSize: '16px' }">
        门店销售
      </van-divider>
    </van-col>
    <van-col :span="24">
      <van-grid>
        <van-grid-item icon="shopping-cart-o" text="新增销售单" />
        <van-grid-item icon="todo-list-o" text="销售单管理" />
      </van-grid>
    </van-col>
    <van-col :span="24">
      <van-divider content-position="center" :style="{ color: '#13C2C2', borderColor:
        '#13C2C2', padding: '0 16px', fontSize: '16px' }">
        门店备货
      </van-divider>
    </van-col>
    <van-col :span="24">
      <van-grid>
        <van-grid-item icon="bill-o" text="新增要货单" />
        <van-grid-item icon="records" text="要货单管理" />
        <van-grid-item icon="exchange" text="新增调拨单" />
        <van-grid-item icon="description" text="调拨单管理" />
      </van-grid>
    </van-col>
    <van-col :span="24">
      <van-divider content-position="center" :style="{ color: '#13C2C2', borderColor:
        '#13C2C2', padding: '0 16px', fontSize: '16px' }">
        销售情况
      </van-divider>
    </van-col>
    <van-col :span="24">
      <van-grid>
        <van-grid-item icon="balance-o" text="销售汇总" />
        <van-grid-item icon="completed" text="库存盘点" />
      </van-grid>
    </van-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Dashboard',
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    logout() {
      this.confirm('确定退出系统吗？').then(async() => {
        this.$store.dispatch('user/logout').then(() => {
          this.$router.push(`/login?redirect=${this.$route.fullPath}`)
        })
      }).catch(_ => {})
    },
    redirect(path) {
      this.$router.push(path)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard.vue